"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionNodes = exports.QuestionNodes = exports.HubOptions = exports.HubTypes = void 0;
const tslib_1 = require("tslib");
const create_1 = require("./create");
const other_1 = require("./other");
var other_2 = require("./other");
Object.defineProperty(exports, "HubTypes", { enumerable: true, get: function () { return other_2.HubTypes; } });
Object.defineProperty(exports, "HubOptions", { enumerable: true, get: function () { return other_2.HubOptions; } });
tslib_1.__exportStar(require("./create"), exports);
tslib_1.__exportStar(require("./questionNames"), exports);
tslib_1.__exportStar(require("./inputs"), exports);
tslib_1.__exportStar(require("./options"), exports);
tslib_1.__exportStar(require("./constants"), exports);
class QuestionNodes {
    createProject() {
        return create_1.createProjectQuestionNode();
    }
    createSampleProject() {
        return create_1.createSampleProjectQuestionNode();
    }
    createProjectCliHelp() {
        return create_1.createProjectCliHelpNode();
    }
    addWebpart() {
        return other_1.addWebPartQuestionNode();
    }
    selectTeamsAppManifest() {
        return other_1.selectTeamsAppManifestQuestionNode();
    }
    validateTeamsApp() {
        return other_1.validateTeamsAppQuestionNode();
    }
    previewWithTeamsAppManifest() {
        return other_1.previewWithTeamsAppManifestQuestionNode();
    }
    listCollaborator() {
        return other_1.listCollaboratorQuestionNode();
    }
    grantPermission() {
        return other_1.grantPermissionQuestionNode();
    }
    deployAadManifest() {
        return other_1.deployAadManifestQuestionNode();
    }
    createNewEnv() {
        return other_1.createNewEnvQuestionNode();
    }
    copilotPluginAddAPI() {
        return other_1.copilotPluginAddAPIQuestionNode();
    }
    apiKey() {
        return other_1.apiSpecApiKeyQuestion();
    }
}
exports.QuestionNodes = QuestionNodes;
exports.questionNodes = new QuestionNodes();
//# sourceMappingURL=index.js.map